module.exports = __webpack_public_path__ + "img/logo.fed23ff1.png";